"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");

var SnapshotType_1 = require("./SnapshotType");
/**
 * @author Adam Drda
 */


var Snapshot =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Snapshot, _DomainObject_1$Domai);

  /**
   * @param id
   * @param date depending on type either date of snapshot creation (WorkflowChanged) or day being snapshot (DailyRegular)
   * @param type type of snapshot
   * @param entityClass name of class of entity stored in the snapshot
   * @param entity stored entity
   * @param entityKpiValues KPI values stored together with the entity or null
   * @param entitySplitWeights
   */
  function Snapshot(id, date, type, entityClass, entity, entityKpiValues, entitySplitWeights) {
    var _this;

    _classCallCheck(this, Snapshot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Snapshot).call(this));
    _this.id = id;
    _this.date = date;
    _this.type = type;
    _this.entityClass = entityClass;
    _this.entity = entity;
    _this.entityKpiValues = entityKpiValues;
    _this.entitySplitWeights = entitySplitWeights;
    return _this;
  }

  _createClass(Snapshot, null, [{
    key: "validateType",
    value: function validateType(stype, date) {
      switch (stype) {
        case SnapshotType_1.SnapshotType.DailyRegular:
          if (utils_1.Utils.isUndefined(date)) {
            throw new Error('DailyRegular requires date of snapshot');
          }

          break;

        case SnapshotType_1.SnapshotType.WorkflowChanged:
          if (date !== undefined && date !== null) {
            throw new Error('WorkflowChanged forbids date of snapshot');
          }

          break;

        default:
          throw new Error('Unsupported snapshot type: ' + stype);
      }
    }
  }]);

  return Snapshot;
}(DomainObject_1.DomainObject);

exports.Snapshot = Snapshot;